<script>
    import { ajaxIsCalling } from '/core/stores/ajaxLoader.js';
    import { fade } from 'svelte/transition';

</script>

{#if $ajaxIsCalling === true}
<div class="progress-container justify-content-center">
    <div class="progress" out:fade|global>
        <span class="progress-bar" style="width: 100%"></span>
    </div>
</div>
{/if}

<style>
.progress-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index:100;
    width: 100%;
    height: 8px;
}
.progress {
  width: 100%;
  height: 8px;
  background: #e1e4e8;
  overflow: hidden;
}
.progress .progress-bar {
  display: block;
  height: 100%;
  background: linear-gradient(90deg, #ffd33d, #ea4aaa 17%, #b34bff 34%, #01feff 51%, #ffd33d 68%, #ea4aaa 85%, #b34bff);
  background-size: 300% 100%;
  -webkit-animation: progress-animation 2s linear infinite;
          animation: progress-animation 2s linear infinite;
}

@-webkit-keyframes progress-animation {
  0% {
    background-position: 100%;
  }
  100% {
    background-position: 0;
  }
}

@keyframes progress-animation {
  0% {
    background-position: 100%;
  }
  100% {
    background-position: 0;
  }
}

</style>